import PropTypes from 'prop-types';

import ShopperHeading from '../Heading';

function Heading({ children }) {
  return (
    <ShopperHeading as="h2" className="mr-10 break-words" size="size4">
      {children}
    </ShopperHeading>
  );
}

Heading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Heading;
